import { render } from "./StatusRenewal.vue?vue&type=template&id=386a1b31"
import script from "./StatusRenewal.vue?vue&type=script&lang=js"
export * from "./StatusRenewal.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__